<template>
    <vx-tooltip :title="title" :text="text" :color="color">
      <feather-icon icon="HelpCircleIcon" svg-classes="text-gray cursor-pointer"/>
    </vx-tooltip>
</template>

<script>
    export default {
        name: 'helper',
        props: {
            text: {
                type: String,
                default: ''
            },
            title: {
                type: String,
                default: null
            },
            color: {
                type: String,
                default: null
            }
        },
    }
</script>
